import script from "./EButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__